import { z, ZodType } from 'zod';
import { jArticleList } from './article';
import { jUserLittle } from './user';
import { filterSchema, orderSchema } from './utils';
import { ArticleFormatsExtension, ArticleWithExtensions } from './withExtensions';

export const getLicenseKindUsersParamsSchema = z.object({
    kind: z.string(),
    page: z.number(),
    limit: z.number(),
    filters: filterSchema.array().optional(),
    orders: orderSchema.array().optional(),
});
export type GetLicenseKindUsersParams = z.infer<typeof getLicenseKindUsersParamsSchema>;

export const inferUserLicenseSchema = <T extends ZodType<jUserLittle>>(type: T) =>
    z.object({
        license: z.union([z.literal('1'), z.literal('0')]),
        user: type,
    });

export type UserLicense<T extends jUserLittle> = z.infer<ReturnType<typeof inferUserLicenseSchema<ZodType<T>>>>;

export type GetLicenseArticle<T extends jArticleList, K extends ArticleFormatsExtension> = {
    article: ArticleWithExtensions<T, K>;
    license: boolean;
};

export const getLicenseArticlesParamsSchema = z.object({
    kind: z.string(),
    type: z.string(),
    page: z.number(),
    limit: z.number(),
    filters: filterSchema.array().optional(),
    orders: orderSchema.array().optional(),
});
export type GetLicenseArticlesParams = z.infer<typeof getLicenseArticlesParamsSchema>;
